import { default as $ } from 'jQuery';

$(function() {
    let map = $('#granted-map');
    let mapMarkers = [];
    let InforObj = [];
    let categories = [];
    let filteredPresentations = [];
    let markerCluster;

    if (!map.data('urls')) return;

    // Get attributes and set all variables
    const API_URLS = map.data('urls').split('\n');
    const MAP_LAT = map.data('lat') || '59.31685847252984';
    const MAP_LNG = map.data('long')|| '15.169545566576824';
    const ZOOM = map.data('zoom') || 9;
    const START_MONTH = map.data('month') || 6;
    const YEARS = map.data('years') || 3;

    // Exit if no URL:s are set
    if (!API_URLS || API_URLS.length === 0) return;

    const loader = $('<div id="map-loader"><i class="fas fa-spinner fa-spin fa-3x"></i></div>"');
    loader.appendTo(map);

    const clusterOptions = {
        ignoreHidden: true,
        styles: [
            {
                anchorText: [8, 0],
                url: "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><circle cx='20' cy='16' r='16' fill='%238dc4bb' /></svg>",
                width: 40,
                height: 40,
                fontFamily: 'arial',
                textSize: 12,
                textColor: '#eef8f3',
            },
        ],
    };

    const centerCords = {
        lat: parseFloat(MAP_LAT),
        lng: parseFloat(MAP_LNG),
    };

    function initData() {
        const currentTime = new Date();
        const month = currentTime.getMonth() + 1;
        const currentYear = month <= START_MONTH ? currentTime.getFullYear() - 1 : currentTime.getFullYear();
        const requests = [];

        // If we have wordpress projects to display in map we fetch them
        if (CUSTOM_DATA && CUSTOM_DATA.projects === '1') {
            requests.push(fetchWordpressProjectData());
        }

        // Create requests for each url
        API_URLS.map(url => {
            for (let i = 0; i < YEARS; i++) {
                requests.push(fetchProjectDataForYear(url, currentYear - i));
            }
        });

        // Wait for all requst to finish before continuing setting up the map
        $.when(...requests).then(() => setupCategories());
    }

    function fetchWordpressProjectData() {
        return $.ajax({
            url: '/wp-json/sbs/projects/',
            cache: false,
            success: function(data) {
                console.log(data);
                data.forEach((project) => {
                    filteredPresentations.push({
                        id: project.project_id,
                        title: project.title,
                        ingress: project.ingress,
                        category: project.category,
                        type: project.type,
                        city: project.city,
                        reciver: project.receiver,
                        img: project.image_url,
                        coordinates: [
                            {
                                lat: parseFloat(project.latitude),
                                lng: parseFloat(project.longitude),
                            },
                        ],
                    });                    
                })
            }
        });
    }

    function fetchProjectDataForYear(url, year) {
        let queryUrl = url.replace(/\/+$/, '') + '?ay=' + year + '&l=1000';
        return $.ajax({
            url: queryUrl,
            cache: false,
            success: function (data) {
                if (data.results && data.results.length > 0) {
                    data.results.forEach((result) => {
                        if (result.showOnMap == 1) {
                            if (
                                result.latitude &&
                                result.latitude !== '' &&
                                !isNaN(parseFloat(result.latitude)) &&
                                result.longitude &&
                                result.longitude !== '' &&
                                !isNaN(parseFloat(result.longitude))
                            ) {
                                filteredPresentations.push({
                                    title: result.altTitle && result.altTitle != '' ? result.altTitle : result.title,
                                    ingress: result.appFormSummary,
                                    category: result.category,
                                    grantedValue: result.grantedValue,
                                    city: result.municipality,
                                    reciver: result.organisation,
                                    coordinates: [
                                        {
                                            lat: parseFloat(result.latitude),
                                            lng: parseFloat(result.longitude),
                                        },
                                    ],
                                });
                            }
                        }
                    });
                }
            }
        });
    }

    function setupCategories() {
        // Add available categoires
        filteredPresentations.forEach((presentation) => {
            let existningCategoryIndex = categories.findIndex(cat => cat.name === presentation.category);
            if (presentation.category && presentation.category !== '') {
                if (existningCategoryIndex !== -1) {
                    categories[existningCategoryIndex].count += 1;
                } else {
                    categories.push({name: presentation.category, count: 1});
                }
            }
        });

        initMap();
    }

    function filterPresentations(category) {
        const mapFilterBtn = $('#map-filter-btn');
        mapFilterBtn.html(category === 'reset' ? 'Kategorier' : category);
        
        mapMarkers.forEach(marker => marker.setVisible(category === 'reset' || marker.category === category));
        markerCluster.repaint();

        // Reset map zoom
        map.setCenter(centerCords);
        map.setZoom(ZOOM);
    }

    function addMarkerInfo() {
        mapMarkers = [];
        
        filteredPresentations.forEach(presentation => {
            let category = presentation.category;

            // Wordpress project
            if (presentation.type) {
                let projectId = presentation.id;

                const marker = new google.maps.Marker({
                    position: presentation.coordinates[0],
                    map: map,
                    category: category,
                    icon: {
                        path: 'M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0',
                        fillColor: presentation.type === 'Samhällsengagemang' ? '#ea692c' : '#f4ca50',
                        fillOpacity: 1,
                        strokeWeight: 0,
                        scale: 0.14,
                    },
                });
                mapMarkers.push(marker);

                let contentString = '<img src="' + presentation.img + '" width="380px" />' + '<div class="content bg-light-apricot">';
                if (presentation.reciver && presentation.city) {
                    contentString += '<span>' + presentation.reciver + ', ' + presentation.city + ': </span>';
                }
                contentString += '<h1>' + presentation.title + '</h1>' + '<p>' + presentation.ingress + '</p>' + '<a href="#" data-project-id="' + projectId + '">Läs mer</a>' + '</div>';

                const infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: 380,
                });

                marker.addListener('click', function () {
                    closeOtherInfo();
                    infowindow.open(marker.get('map'), marker);
                    InforObj[0] = infowindow;
                });

                map.addListener('click', function() {
                    infowindow.close();
                });

                infowindow.addListener('domready', function () {
                    $('a[data-project-id="' + projectId + '"]').on('click', function (e) {
                        e.preventDefault();
                        let project = $('.project[data-project-id="' + $(this).data('projectId') + '"]');
                        if (project.length) {
                            project.trigger('click');
                            closeOtherInfo();
                        }
                    });
                });
            } else {
                const marker = new google.maps.Marker({
                    position: presentation.coordinates[0],
                    map: map,
                    category: category,
                    icon: {
                        path: 'M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0',
                        fillColor: '#b55d97',
                        fillOpacity: 1,
                        strokeWeight: 0,
                        scale: 0.14,
                    },
                });
                mapMarkers.push(marker);

                let amount = presentation.grantedValue
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

                let contentString =
                    '<div class="content bg-light-apricot">' +
                        '<span>' +
                            presentation.reciver +
                            ', ' +
                            presentation.city +
                        ': </span>' +
                        '<h1>' +
                            presentation.title +
                        '</h1>' +
                        '<p>Beviljat belopp: ' +
                            amount +
                        ' kr</p>' +
                    '</div>';

                const infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: 380,
                });

                map.addListener('click', function() {
                    infowindow.close();
                });

                marker.addListener('click', function () {
                    closeOtherInfo();
                    infowindow.open(marker.get('map'), marker);
                    InforObj[0] = infowindow;
                });
            }
        });
            
        markerCluster = new MarkerClusterer(map, mapMarkers, clusterOptions);

        // All done so we hide loader
        $('#map-loader').hide();
    }

    function closeOtherInfo() {
        if (InforObj.length > 0) {
            InforObj[0].set('marker', null);
            InforObj[0].close();
            InforObj.length = 0;
        }
    }

    function initMap() {
        map = new google.maps.Map(document.getElementById('granted-map'), {
            zoom: ZOOM,
            center: centerCords,
            maxZoom: 19,
            minZoom: 6,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: [
                { elementType: 'geometry', stylers: [{ color: '#212121' }] },
                {
                    elementType: 'labels.text.stroke',
                    stylers: [{ visibility: 'off' }],
                },
                { elementType: 'labels.text.fill', stylers: [{ color: '#737373' }] },
                {
                    featureType: 'administrative.locality',
                    elementType: 'labels.text.fill',
                    stylers: [{ color: '#737373' }],
                },
                {
                    featureType: 'poi',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'poi.business',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'poi.park',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [{ color: '#363636' }],
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.stroke',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'road',
                    elementType: 'labels.text.fill',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels',
                    stylers: [{visibility: 'off'}]
                },
                {
                    featureType: 'road.local',
                    elementType: 'labels',
                    stylers: [{ visibility: 'off'}]
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry',
                    stylers: [{ color: '#363636' }],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'labels',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'transit',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'transit.station',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [{ color: '#111111' }],
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.fill',
                    stylers: [{ color: '#515c6d' }],
                },
                {
                    featureType: 'water',
                    elementType: 'labels.text.stroke',
                    stylers: [{ visibility: 'off' }],
                },
            ],
        });

        // Filter category btn
        if (categories.length > 0) {
            let html = '<div class="btn-group dropup"><button id="map-filter-btn" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true" aria-expanded="false">Kategorier</button><div class="dropdown-menu">';
            categories.forEach(category => {
                html += '<a class="dropdown-item filter-category" data-category="' + category.name + '" href="#">' + category.name + ' (' + category.count + ')</a>';
            });
            html += '<a class="dropdown-item filter-category" data-category="reset" href="#">Visa alla (' + filteredPresentations.length + ')</a>';
            html += '</div></div>';
            let el = $(html);

            map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(el[0]);

            el.find('.filter-category').on('click', function(e) {
                e.preventDefault();
                filterPresentations($(this).data('category'));
            });	
        }

        addMarkerInfo();
    }

    initData();
});